module.exports = __webpack_public_path__ + "23060ec23044bcbdbc40a2c6ec428096.gif";